import type { AuthTenantOption, AuthUser } from 'shared-models/browser';
import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

class AuthService {
  async me(): Promise<AuthUser> {
    try {
      const response = await authenticatedInstance.get<AuthUser>('/auth/me');
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  // Summary: Fetches tenant options available for the current authenticated user to support tenant switching UX.
  // Details: docs/function-library/web/services.md#auth-service
  async tenants(): Promise<AuthTenantOption[]> {
    try {
      const response = await authenticatedInstance.get<AuthTenantOption[]>('/auth/tenants');
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  // Summary: Triggers server-side auth cookie clearing so browser session is invalidated consistently across tabs and refreshes.
  // Details: docs/function-library/web/services.md#auth-service
  async logout(): Promise<void> {
    try {
      await authenticatedInstance.post('/auth/logout');
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const authService = new AuthService();




